import { SpinnerIcon, AlertIcon } from './icons';

/** Full-step loading spinner. */
export function LoadingState({ label }: { label: string; }) {
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 text-ink-500">
      <SpinnerIcon className="h-6 w-6 text-brand-500" />
      <p className="text-sm">{label}</p>
    </div>
  );
}

/** Full-step error. */
export function ErrorState({ message }: { message: string; }) {
  return (
    <div className="card mx-auto max-w-md p-6 text-center">
      <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-danger-500/10 text-danger-600">
        <AlertIcon className="h-5 w-5" />
      </div>
      <h2 className="text-base font-semibold text-ink-900">Something went wrong</h2>
      <p className="mt-1 text-sm text-ink-500">{message}</p>
      <button
        className="btn-secondary mt-4"
        onClick={() => window.location.reload()}
      >
        Retry
      </button>
    </div>
  );
}

/**
 * Session-missing state — the session cookie isn't valid (or never set). The
 * only recovery is to re-enter via the HubSpot install flow (which mints a
 * fresh one-time token → new session cookie via /auth/start).
 */
export function UnauthState() {
  return (
    <div className="card mx-auto max-w-md p-8 text-center">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-warn-500/10 text-warn-600">
        <AlertIcon className="h-6 w-6" />
      </div>
      <h1 className="text-lg font-semibold text-ink-900">Session expired</h1>
      <p className="mt-2 text-sm text-ink-500">
        Your setup session has expired or wasn't started from HubSpot. Re-open
        the app from your HubSpot account to continue.
      </p>
      <a
        href="https://app.hubspot.com"
        target="_blank"
        rel="noreferrer"
        className="btn-primary mt-5"
      >
        Open HubSpot
      </a>
    </div>
  );
}
